import { NoTimeLeftModal } from './NoTimeLeftModal';

export default NoTimeLeftModal;